<script setup lang="ts">
import { useAuthStore } from '@/modules/auth/store/auth';
import { useMobileStore } from '@/store/mobile';
import type { SidebarMenu } from '@/types/SidebarMenu';
import { storeToRefs } from 'pinia';
import NavbarMenu from './NavbarMenu.vue';
import AppLogo from './base/AppLogo.vue';

interface Props {
  prependMenu?: SidebarMenu[];
  appendMenu?: SidebarMenu[];
}
const { prependMenu = [], appendMenu = [] } = defineProps<Props>();

const { user } = storeToRefs(useAuthStore());
const mobileStore = useMobileStore();
const { showMenu } = storeToRefs(mobileStore);
const { toggleMenu } = mobileStore;

onMounted(() => {
  toggleMenu(true);
});
</script>

<template>
  <div v-if="showMenu" class="the-sidebar ma-4 pa-4">
    <nuxt-link to="/" class="d-flex flex-column align-center text-decoration-none font-weight-medium text-black mb-12">
      <AppLogo width="48px" height="48px" class="mb-4" />
      Appetiser Apps
    </nuxt-link>

    <NavbarMenu :prepend-menu="prependMenu" :append-menu="appendMenu" />
  </div>
</template>

<style lang="scss" scoped>
.the-sidebar {
  border-radius: 8px;
  border: 1px solid whitesmoke;
}
</style>
